import { ClinicianInactiveTag } from '@/components/clinicians/ClinicianInactiveTag';
import { Avatar, Badge, SxProps, Theme, styled } from '@mui/material';

const CONTAINER_NAME = 'clinician-chip';

// Below this container width an inactive chip swaps its text tag for an avatar icon.
const ICON_ONLY_BELOW_PX = 180;

const NARROW = `@container ${CONTAINER_NAME} (max-width: ${ICON_ONLY_BELOW_PX}px)`;

// Keeps the avatar readable while dropping it out of the row's foreground.
const INACTIVE_OPACITY = 0.6;

const INACTIVE_ICON_SIZE_PX = 10;

export const INACTIVE_ICON_SX = { fontSize: INACTIVE_ICON_SIZE_PX } satisfies SxProps<Theme>;

// Set on the element whose width decides between the inactive tag and the inactive icon.
export const CLINICIAN_CHIP_CONTAINER_SX = {
    containerType: 'inline-size',
    containerName: CONTAINER_NAME,
} satisfies SxProps<Theme>;

// Lays the name and the tag out so the name ellipsizes and the tag stays whole.
export const InactiveLabel = styled('span')({
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
});

export const InactiveName = styled('span')({
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
});

// Pulls into the label's right padding so the tag's right gap matches its top and bottom gaps.
export const InactiveChipTag = styled(ClinicianInactiveTag)({
    flexShrink: 0,
    marginRight: -4,
    [NARROW]: {
        '&&': { display: 'none' },
    },
});

// Receives Chip's avatar class, so the chip's avatar size and margins land here.
export const InactiveAvatarBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        display: 'none',
        padding: 0,
        minWidth: 0,
        height: 'auto',
        borderRadius: '50%',
        backgroundColor: theme.palette.background.paper,
    },
    [NARROW]: {
        '& .MuiBadge-badge': { display: 'flex' },
    },
}));

export const InactiveAvatar = styled(Avatar)({
    width: '100%',
    height: '100%',
    fontSize: 'inherit',
    opacity: INACTIVE_OPACITY,
});
